import { render, staticRenderFns } from "./CartWatch.vue?vue&type=template&id=0976d85f&"
import script from "./CartWatch.vue?vue&type=script&lang=js&"
export * from "./CartWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports